import React, { PureComponent } from 'react';
import { Col, Row } from 'react-flexbox-grid';
import { getTextFactory } from 'utils/TextUtils';
import { InjectedIntl } from 'react-intl';
import SummaryField from './SummaryField';
import { SummaryProInvolvement } from '../types';
import { KycQuestionData } from 'hooks/useKycQuestion/useKycQuestion';

type ProInvolvementSectionProps = {
  intl: InjectedIntl;
  proInvolvement: SummaryProInvolvement | null | undefined;
  labelOverrides?: Record<string, KycQuestionData>;
};

export class ProInvolvementSection extends PureComponent<ProInvolvementSectionProps> {
  getGlobalText = getTextFactory(this.props.intl, 'global');
  getText = getTextFactory(this.props.intl, 'employmentV2');

  renderInvestmentFirmEmployeeRow = () => {
    const { locale } = this.props.intl;
    const { proInvolvement } = this.props;
    return (
      <Row>
        {proInvolvement?.investmentFirmEmployeeInd && (
          <Col xs={12}>
            <SummaryField
              dataTest="employment_investmentFirmEmployeeInd"
              label={this.getText('proInvolvementRelation')}
            >
              {this.getText('myself')}
            </SummaryField>
          </Col>
        )}
        {proInvolvement?.familyInvestmentFirmEmployeeInd && (
          <>
            <Col xs={12} md={6}>
              <SummaryField
                dataTest="employment_familyInvestmentFirmEmployeeType"
                label={this.getText('proInvolvementRelation')}
              >
                {proInvolvement.familyInvestmentFirmEmployeeType?.[locale]}
              </SummaryField>
            </Col>
            <Col xs={12} md={6}>
              <SummaryField
                dataTest="employment_familyInvestmentFirmEmployeeFullName"
                label={this.getText('personName')}
              >
                {proInvolvement.familyInvestmentFirmEmployeeFullName}
              </SummaryField>
            </Col>
          </>
        )}
      </Row>
    );
  };

  renderProfessionalRow = () => {
    const { locale } = this.props.intl;
    const { proInvolvement } = this.props;
    return (
      <Row>
        {proInvolvement?.professionalInd && (
          <>
            <Col xs={12} md={6}>
              <SummaryField dataTest="employment_professionalInd" label={this.getText('proInvolvementRelation')}>
                {this.getText('myself')}
              </SummaryField>
            </Col>
            <Col xs={12} md={6}>
              <SummaryField
                dataTest="employment_professionalSecuritiesFirmName"
                label={this.getText('securitiesFirmName')}
              >
                {proInvolvement.professionalSecuritiesFirmName}
              </SummaryField>
            </Col>
          </>
        )}
        {proInvolvement?.referenceProfessionalInd && (
          <>
            <Col xs={12} md={6}>
              <SummaryField
                dataTest="employment_referenceProfessionalRelationType"
                label={this.getText('proInvolvementRelation')}
              >
                {proInvolvement.referenceProfessionalRelationType?.[locale]}
              </SummaryField>
            </Col>
            <Col xs={12} md={6}>
              <SummaryField
                dataTest="employment_referenceProfessionalSecuritiesFirmName"
                label={this.getText('securitiesFirmName')}
              >
                {proInvolvement.referenceProfessionalSecuritiesFirmName}
              </SummaryField>
            </Col>
            <Col xs={12} md={6}>
              <SummaryField dataTest="employment_referenceProfessionalFullName" label={this.getText('personName')}>
                {proInvolvement.referenceProfessionalFullName}
              </SummaryField>
            </Col>
          </>
        )}
      </Row>
    );
  };

  render() {
    const { proInvolvement } = this.props;
    if (!proInvolvement) return null;

    const hasInvestmentFirmEmployee = this.getGlobalText(
      proInvolvement?.investmentFirmEmployeeInd || proInvolvement?.familyInvestmentFirmEmployeeInd ? 'true' : 'false',
    );
    const hasProfessional = this.getGlobalText(
      proInvolvement?.professionalInd || proInvolvement?.referenceProfessionalInd ? 'true' : 'false',
    );

    return (
      <Col key="proInvolvement" xs={12}>
        <Row>
          <Col xs={12}>
            <SummaryField
              dataTest="employment_firmEmployeeQuestionInd"
              label={this.props.labelOverrides?.firmEmployeeQuestionInd?.title || this.getText('firmEmployeeQuestion')}
            >
              {hasInvestmentFirmEmployee}
            </SummaryField>
            {hasInvestmentFirmEmployee && this.renderInvestmentFirmEmployeeRow()}
          </Col>
          <Col xs={12}>
            <SummaryField
              dataTest="employment_professionalQuestionInd"
              label={this.props.labelOverrides?.professionalQuestionInd?.title || this.getText('professionalQuestion')}
            >
              {hasProfessional}
            </SummaryField>
            {hasProfessional && this.renderProfessionalRow()}
          </Col>
        </Row>
      </Col>
    );
  }
}

export default ProInvolvementSection;
